import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-bc3264ac"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "map-modal__map-block" }
const _hoisted_3 = { class: "pin" }

import {
  YandexMap,
  YandexMapDefaultFeaturesLayer,
  YandexMapDefaultSchemeLayer,
  YandexMapMarker,
} from 'vue-yandex-maps';
import { computed, ref, Ref, shallowRef, triggerRef, watch } from 'vue';
import type { YMapDefaultMarker } from '@yandex/ymaps3-types/packages/markers';
import type { LngLat } from '@yandex/ymaps3-types';
import { getAddressByGeolocate } from '@/api/ymaps';
import { useAppStore } from '@/store/modules/app';


export default /*#__PURE__*/_defineComponent({
  __name: 'MapModal',
  props: {
    showModal: { type: Boolean },
    point: {},
    addressValue: {}
  },
  emits: ['close', 'changePoint'],
  setup(__props: any, { emit: __emit }) {

const defaultMarker = shallowRef<YMapDefaultMarker | null>(null);
const address: Ref<string> = ref('');

const currentCoordinates = computed(() => {
  const point = defaultMarker.value ? defaultMarker.value.coordinates : props.point;

  if (point[0] === 0 && point[1] === 0) {
    return [39.720353, 47.22208];
  }

  return point;
});
const onDragMove = () => {
  triggerRef(defaultMarker);
};
const onDragEnd = () => {
  if (defaultMarker.value) {
    getAddressByGeolocate({
      lat: +currentCoordinates.value[1],
      lon: +currentCoordinates.value[0],
    }).then(res => {
      address.value = res.data.suggestions[0].value;
    });
  }
};

const props = __props;
const emit = __emit;
const saveChanges = () => {
  emit('changePoint', {
    point: [
      (+currentCoordinates.value[0]).toFixed(6),
      (+currentCoordinates.value[1]).toFixed(6),
    ],
    address: address.value,
  });
  emit('close');
};

watch(
  () => props.addressValue,
  () => {
    address.value = props.addressValue;
  },
);

return (_ctx: any,_cache: any) => {
  const _component_base_image = _resolveComponent("base-image")!
  const _component_base_button = _resolveComponent("base-button")!
  const _component_base_modal = _resolveComponent("base-modal")!

  return (_openBlock(), _createBlock(_component_base_modal, {
    fullScreen: _unref(useAppStore)().getWindowWidth() < 600,
    "show-modal": _ctx.showModal,
    "close-outside": "",
    title: "Геоданные",
    onClose: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('close')))
  }, {
    content: _withCtx(() => [
      _createElementVNode("div", null, _toDisplayString(`Адрес: ${address.value ?? '-'}`), 1),
      (currentCoordinates.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(`Долгота: ${(+currentCoordinates.value[0]).toFixed(6)} Широта: ${(+currentCoordinates.value[1]).toFixed(9)}`), 1))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_unref(YandexMap), {
          settings: {
            location: {
              center: _ctx.point && _ctx.point[0] !== 0 ? _ctx.point : [39.720353, 47.22208],
              zoom: 15,
            },
          },
          height: "100%",
          width: "100%"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(YandexMapDefaultSchemeLayer)),
            _createVNode(_unref(YandexMapDefaultFeaturesLayer)),
            _createVNode(_unref(YandexMapMarker), {
              modelValue: defaultMarker.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((defaultMarker).value = $event)),
              settings: {
              coordinates: defaultMarker.value ? defaultMarker.value.coordinates : currentCoordinates.value,
              draggable: true,
              onDragMove: onDragMove,
              onDragEnd: onDragEnd,
            }
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_3, [
                  _createVNode(_component_base_image, {
                    src: require('@/assets/img/banner/icon-for-map.svg'),
                    contain: "",
                    name: "map"
                  }, null, 8, ["src"])
                ])
              ]),
              _: 1
            }, 8, ["modelValue", "settings"])
          ]),
          _: 1
        }, 8, ["settings"])
      ])
    ]),
    btn: _withCtx(() => [
      _createVNode(_component_base_button, {
        height: "40",
        text: "Применить",
        onClick: saveChanges
      })
    ]),
    _: 1
  }, 8, ["fullScreen", "show-modal"]))
}
}

})